var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sd_fansNumber_pendant"},[(_vm.url)?_c('img',{style:({ width: (_vm.width + "px"), height: (_vm.width + "px") }),attrs:{"src":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }